export default {
  submitButton: 'proposal-vote-modal-submit-button',
};
